/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaSelectOneValues from 'DesignSystem/TysiaSelectOne/TysiaSelectOneValues/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentStatus({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/AppointmentBookingStateUpdate/AppointmentStatus",
  onChange
  
}) {
let appointmentStatusesValueData = fromData.useDataValue({ viewPath,
context: 'appointment_statuses',
})
let selectedEventDataValuetoValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'event.data.valueTo',
})
let selectedEventDataValuetoChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'event.data.valueTo',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 size="small"
 data="appointment_statuses"
 from={appointmentStatusesValueData}
 data="selected.event.data.valueTo"
 onChange={selectedEventDataValuetoChangeData}
 value={selectedEventDataValuetoValueData}
 marginTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Select the appointment status to trigger the automation"
/>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
<TysiaSelectOneValues
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneValues`}
/>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}